
/**
 * 통화 코드
 */
export type CreateCourseDraft201PriceCurrency = typeof CreateCourseDraft201PriceCurrency[keyof typeof CreateCourseDraft201PriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201PriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
